import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Menu = props => {
  return (
    <SvgIcon {...props}>
      <path d="M2 5V7H22V5H2ZM2 11V13H22V11H2ZM2 17V19H22V17H2Z" />
    </SvgIcon>
  );
};

export default SvgI24Menu;
